<div *ngIf="noteContent" class="inscription-note tw-p-4 tw-text-sm tw-bg-gray-200 tw-mt-4 tw-rounded-md">
    <div [innerHTML]="noteContent"></div>
</div>
